import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { DatePicker, TimePicker } from 'antd'
import { Text } from '@lmc/ui-kit/src/general'
import type { Dayjs } from 'dayjs'
import { Stack } from './ReconcileModalStack'
import { DATE_FORMAT, TIME_FORMAT } from 'screens/Rostering/utils.datetime'

export type CustomTimeRangePickersProps = {
  customStartDate: Dayjs | null
  setCustomStartDate: (v: Dayjs | null) => void
  customStartTime: Dayjs | null
  setCustomStartTime: (v: Dayjs | null) => void
  customEndDate: Dayjs | null
  setCustomEndDate: (v: Dayjs | null) => void
  customEndTime: Dayjs | null
  setCustomEndTime: (v: Dayjs | null) => void
}

export function CustomTimeRangePickers({
  customStartDate,
  setCustomStartDate,
  customStartTime,
  setCustomStartTime,
  customEndDate,
  setCustomEndDate,
  customEndTime,
  setCustomEndTime
}: CustomTimeRangePickersProps) {
  const { t } = useTranslation()
  return (
    <CustomTimeGrid>
      <Stack>
        <MutedLabel>{t('RECONCILIATION_START_DATE')}</MutedLabel>
        <DatePicker
          format={DATE_FORMAT}
          value={customStartDate}
          onChange={setCustomStartDate}
          style={{ width: '100%' }}
        />
      </Stack>
      <Stack>
        <MutedLabel>
          {t('RECONCILIATION_CUSTOM_TIME_START_TIME_LABEL')}
        </MutedLabel>
        <TimePicker
          format={TIME_FORMAT}
          needConfirm={false}
          value={customStartTime}
          onChange={setCustomStartTime}
          style={{ width: '100%' }}
        />
      </Stack>
      <Stack>
        <MutedLabel>{t('RECONCILIATION_END_DATE')}</MutedLabel>
        <DatePicker
          format={DATE_FORMAT}
          value={customEndDate}
          onChange={setCustomEndDate}
          style={{ width: '100%' }}
        />
      </Stack>
      <Stack>
        <MutedLabel>
          {t('RECONCILIATION_CUSTOM_TIME_END_TIME_LABEL')}
        </MutedLabel>
        <TimePicker
          format={TIME_FORMAT}
          needConfirm={false}
          value={customEndTime}
          onChange={setCustomEndTime}
          style={{ width: '100%' }}
        />
      </Stack>
    </CustomTimeGrid>
  )
}

const MutedLabel = styled(Text).attrs({ level: 1, weight: 'regular' })`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const CustomTimeGrid = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 8px;
  width: 100%;
  min-width: 0;
  padding: 16px;
  background: ${({ theme }) => theme.color.neutral.color10};
  border: 1px solid ${({ theme }) => theme.color.neutral.color9};
  border-radius: 20px;
`
